/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SponsoredRewardEmail } from './SponsoredRewardEmail';
import {
    SponsoredRewardEmailFromJSON,
    SponsoredRewardEmailFromJSONTyped,
    SponsoredRewardEmailToJSON,
    SponsoredRewardEmailToJSONTyped,
} from './SponsoredRewardEmail';
import type { CreateSponsoredRewardRequest } from './CreateSponsoredRewardRequest';
import {
    CreateSponsoredRewardRequestFromJSON,
    CreateSponsoredRewardRequestFromJSONTyped,
    CreateSponsoredRewardRequestToJSON,
    CreateSponsoredRewardRequestToJSONTyped,
} from './CreateSponsoredRewardRequest';

/**
 * 
 * @export
 * @interface CreateSponsoredCompetitionBody
 */
export interface CreateSponsoredCompetitionBody {
    /**
     * 
     * @type {string}
     * @memberof CreateSponsoredCompetitionBody
     */
    sponsorBrandName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSponsoredCompetitionBody
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSponsoredCompetitionBody
     */
    promotionImage: string;
    /**
     * 
     * @type {Array<CreateSponsoredRewardRequest>}
     * @memberof CreateSponsoredCompetitionBody
     */
    rewards: Array<CreateSponsoredRewardRequest>;
    /**
     * 
     * @type {number}
     * @memberof CreateSponsoredCompetitionBody
     */
    runningMonth: number;
    /**
     * 
     * @type {number}
     * @memberof CreateSponsoredCompetitionBody
     */
    runningYear: number;
    /**
     * 
     * @type {SponsoredRewardEmail}
     * @memberof CreateSponsoredCompetitionBody
     */
    email?: SponsoredRewardEmail;
    /**
     * URL to the brand's website (to display on competition page)
     * @type {string}
     * @memberof CreateSponsoredCompetitionBody
     */
    brandUrl: string;
}

/**
 * Check if a given object implements the CreateSponsoredCompetitionBody interface.
 */
export function instanceOfCreateSponsoredCompetitionBody(value: object): value is CreateSponsoredCompetitionBody {
    if (!('sponsorBrandName' in value) || value['sponsorBrandName'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('promotionImage' in value) || value['promotionImage'] === undefined) return false;
    if (!('rewards' in value) || value['rewards'] === undefined) return false;
    if (!('runningMonth' in value) || value['runningMonth'] === undefined) return false;
    if (!('runningYear' in value) || value['runningYear'] === undefined) return false;
    if (!('brandUrl' in value) || value['brandUrl'] === undefined) return false;
    return true;
}

export function CreateSponsoredCompetitionBodyFromJSON(json: any): CreateSponsoredCompetitionBody {
    return CreateSponsoredCompetitionBodyFromJSONTyped(json, false);
}

export function CreateSponsoredCompetitionBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSponsoredCompetitionBody {
    if (json == null) {
        return json;
    }
    return {
        
        'sponsorBrandName': json['sponsorBrandName'],
        'description': json['description'],
        'promotionImage': json['promotionImage'],
        'rewards': ((json['rewards'] as Array<any>).map(CreateSponsoredRewardRequestFromJSON)),
        'runningMonth': json['runningMonth'],
        'runningYear': json['runningYear'],
        'email': json['email'] == null ? undefined : SponsoredRewardEmailFromJSON(json['email']),
        'brandUrl': json['brandUrl'],
    };
}

export function CreateSponsoredCompetitionBodyToJSON(json: any): CreateSponsoredCompetitionBody {
    return CreateSponsoredCompetitionBodyToJSONTyped(json, false);
}

export function CreateSponsoredCompetitionBodyToJSONTyped(value?: CreateSponsoredCompetitionBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sponsorBrandName': value['sponsorBrandName'],
        'description': value['description'],
        'promotionImage': value['promotionImage'],
        'rewards': ((value['rewards'] as Array<any>).map(CreateSponsoredRewardRequestToJSON)),
        'runningMonth': value['runningMonth'],
        'runningYear': value['runningYear'],
        'email': SponsoredRewardEmailToJSON(value['email']),
        'brandUrl': value['brandUrl'],
    };
}

